export const getNumberString = (n: number) => (n < 10 ? '0' + n : n.toString())
